// PDF dosya adı oluşturma fonksiyonu
// generatePDFHTML artık backend'de kullanılıyor, bu dosya sadece dosya adı için

const sanitizeFileName = (text) => {
  return text
    .toLowerCase()
    .replace(/ç/g, 'c')
    .replace(/ğ/g, 'g')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ş/g, 's')
    .replace(/ü/g, 'u')
    .replace(/[^a-z0-9]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};

export const generatePDFFileName = (brandName, productTypes) => {
  const parts = [];
  
  if (brandName && brandName.trim()) {
    parts.push(sanitizeFileName(brandName.trim()));
  }
  
  if (productTypes && productTypes.length > 0) {
    const productNames = productTypes.map(type => {
      const shortNames = {
        cay: 'cay',
        turkKahvesi: 'turk-kahvesi',
        filtreKahve: 'filtre-kahve',
        espresso: 'espresso',
      };
      return shortNames[type] || type;
    });
    parts.push(productNames.join('-'));
  }
  
  const now = new Date();
  const dateStr = now.toISOString().split('T')[0];
  parts.push(dateStr);
  
  const fileName = parts.length > 0 ? parts.join('_') : 'okkalikahve-teklif';
  
  return `${fileName}.pdf`;
};

